(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koios-brand-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var INITED = 'data-koios-story-inited';

    function initStory(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;
      if (!root.classList.contains('is-reveal')) {
        root.setAttribute(INITED, 'true');
        return;
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion || !('IntersectionObserver' in window)) {
        root.classList.add('is-visible');
        root.setAttribute(INITED, 'true');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );

      observer.observe(root);
      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-koios-brand-story][data-section-id]');
      for (var i = 0; i < roots.length; i++) initStory(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koios-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var INITED = 'data-koios-hero-inited';

    function initHero(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;

      var track = root.querySelector('.koios-hero__track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.koios-hero__slide'));
      if (slides.length <= 1) {
        root.setAttribute(INITED, 'true');
        return;
      }

      var sectionId = root.getAttribute('data-section-id');
      var prevBtn = document.getElementById('KoiosHeroPrev-' + sectionId);
      var nextBtn = document.getElementById('KoiosHeroNext-' + sectionId);
      var dotsWrap = document.getElementById('KoiosHeroDots-' + sectionId);
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
      var current = 0;
      var timer = null;
      var touchStartX = 0;

      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'koios-hero__dot' + (i === current ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
          dot.addEventListener('click', function () {
            current = i;
            update();
            restartAuto();
          });
          dotsWrap.appendChild(dot);
        });
      }

      function update() {
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        renderDots();
      }

      function next() {
        current = (current + 1) % slides.length;
        update();
      }

      function prev() {
        current = (current - 1 + slides.length) % slides.length;
        update();
      }

      function stopAuto() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      function startAuto() {
        if (!autoplay || reducedMotion) return;
        timer = setInterval(next, speed);
      }

      function restartAuto() {
        stopAuto();
        startAuto();
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
          restartAuto();
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
          restartAuto();
        });
      }

      root.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );
      root.addEventListener(
        'touchend',
        function (e) {
          var diff = e.changedTouches[0].screenX - touchStartX;
          if (Math.abs(diff) > 50) {
            diff > 0 ? prev() : next();
            restartAuto();
          }
        },
        { passive: true }
      );

      root.addEventListener('mouseenter', stopAuto);
      root.addEventListener('mouseleave', startAuto);

      update();
      startAuto();
      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-koios-hero][data-section-id]');
      for (var i = 0; i < roots.length; i++) initHero(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
